var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { parseUrl, stringifyUrl } from "query-string";
import { useState } from "react";
import { AnalyticsForm } from "../AnalyticsForm";
import { isNotUndefined, isNotUndefinedOrNull, isUndefined, postForm } from "../FunctionsCore";
import { CompanyAutoComplete } from "./CompanyAutoComplete";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogActions-root": {
        "background": "#0078a7",
        "color": theme.palette.common.white,
        "padding": theme.spacing(1),
    },
    "& .MuiDialogContent-root": {
        "background": "#0078a7",
        "color": theme.palette.common.white,
        "padding": theme.spacing(2)
    },
    "& h2.MuiDialogTitle-root": {
        "background": "#0078a7",
        "color": theme.palette.common.white,
        "fontSize": "1.25rem",
        "margin": "0px",
        "padding": theme.spacing(2)
    },
}));
const BootstrapDialogTitle = (props) => {
    const { children, onClose, text } = props, other = __rest(props, ["children", "onClose", "text"]);
    return (_jsxs(DialogTitle, Object.assign({ sx: { "m": 0, "p": 2 } }, other, { children: [children, _jsx(IconButton, Object.assign({ "aria-label": "close", onClick: onClose, sx: {
                    "color": (theme) => theme.palette.common.white,
                    "fontSize": 14,
                    "position": "absolute",
                    "right": 8,
                    "top": 8,
                } }, { children: text }))] })));
};
const CompanySelectorDialog = (props) => {
    const { actionMagentoCart, freemiumProduct } = props;
    let configPropsToUse;
    let countryIdToUse;
    let displayNameToUse;
    let displayPriceToUse;
    let flowToUse;
    let labelToUse;
    let priceToUse;
    let productDisplayNameToUse;
    let skuNumberToUse;
    let subscriptionModelToUse;
    if (isNotUndefined(actionMagentoCart)) {
        const { configProps, displayName, displayPrice, label, price, productDisplayName, skuNumber, subscriptionModel } = actionMagentoCart;
        configPropsToUse = configProps;
        countryIdToUse = void 0;
        displayNameToUse = displayName;
        displayPriceToUse = displayPrice;
        flowToUse = void 0;
        labelToUse = label;
        priceToUse = price;
        productDisplayNameToUse = productDisplayName;
        skuNumberToUse = skuNumber;
        subscriptionModelToUse = subscriptionModel;
    }
    else if (isNotUndefined(freemiumProduct)) {
        const { configProps, countryID, displayPrice, flow, label, productDisplayName } = freemiumProduct;
        configPropsToUse = configProps;
        countryIdToUse = countryID;
        displayNameToUse = void 0;
        displayPriceToUse = displayPrice;
        flowToUse = flow;
        labelToUse = label;
        priceToUse = void 0;
        productDisplayNameToUse = productDisplayName;
        skuNumberToUse = void 0;
        subscriptionModelToUse = void 0;
    }
    else {
        throw new Error('Both "actionMagentoCart" and "freemiumProduct" are undefined');
    }
    const { afterInputText, cpSignInUrl, dnb_cart_api_key, dnb_cart_token_value, magento_cart_add_domain, magento_cart_add_endpoint, magento_cart_servlet_path, page_country_code, page_locale, page_locale_country, popupBeforeInput, popupBeforeInputSearch, popupBeforeInputSearchMinCharactersRequirement, popupCancelButtonLabel, popupInputPlaceholder, popupNextButtonLabel, popupOptionNoResultsWereFound, popupProductPrice, popupProductTitle, popupTitle, popupURLNoResultsWereFound } = configPropsToUse;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState();
    const clickHandler = () => {
        if (isNotUndefinedOrNull(flowToUse)) {
            const { url } = parseUrl(cpSignInUrl);
            const href = stringifyUrl({
                "query": {
                    "countryId": countryIdToUse,
                    "dunsNumber": selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.duns,
                    "flow": flowToUse
                },
                "url": url
            });
            window.location.href = href;
        }
        else {
            const cartObjectForPayload = {
                "_token": dnb_cart_token_value,
                "api_key": dnb_cart_api_key,
                "companyName": selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.primaryName,
                "displayName": displayNameToUse,
                "dunsNumber": selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.duns,
                "locale": page_locale,
                "newCartAddToCartUrl": magento_cart_add_domain + magento_cart_add_endpoint,
                "price": priceToUse,
                "qty": "1",
                "sku": skuNumberToUse,
                "subscription_label": subscriptionModelToUse,
                "unique_id": ""
            };
            postForm(magento_cart_servlet_path, cartObjectForPayload, "get");
        }
    };
    const handleClose = () => setIsOpen(false);
    const cartObjectForAnalytics = {
        "companyName": selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.primaryName,
        "displayName": displayNameToUse,
        "dunsNumber": selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.duns,
        "locale": page_locale,
        "price": priceToUse,
        "qty": "1",
        "sku": skuNumberToUse,
        "subscription_label": subscriptionModelToUse,
    };
    return (_jsxs("div", { children: [_jsx("button", Object.assign({ className: "button-primary", onClick: () => setIsOpen(true), type: "button" }, { children: labelToUse })), _jsxs(BootstrapDialog, Object.assign({ "aria-labelledby": "customized-dialog-title", fullWidth: true, maxWidth: "md", onClose: handleClose, open: isOpen }, { children: [_jsx(BootstrapDialogTitle, Object.assign({ id: "customized-dialog-title", onClose: handleClose, text: popupCancelButtonLabel }, { children: popupTitle })), _jsxs(DialogContent, Object.assign({ dividers: true }, { children: [_jsxs(Box, Object.assign({ sx: { "display": "flex", "justifyContent": "space-between" } }, { children: [_jsx(Typography, Object.assign({ gutterBottom: true }, { children: popupProductTitle })), _jsx(Typography, Object.assign({ gutterBottom: true, variant: "h6" }, { children: _jsx("span", { dangerouslySetInnerHTML: { "__html": productDisplayNameToUse } }) }))] })), _jsxs(Box, Object.assign({ sx: { "display": "flex", "justifyContent": "space-between" } }, { children: [_jsx(Typography, Object.assign({ gutterBottom: true }, { children: popupProductPrice })), _jsx(Typography, Object.assign({ gutterBottom: true, variant: "h6" }, { children: _jsx("span", { className: "analytics-pricing-modal", dangerouslySetInnerHTML: { "__html": displayPriceToUse } }) }))] })), _jsx(Typography, Object.assign({ gutterBottom: true }, { children: popupBeforeInput })), _jsxs(Typography, Object.assign({ gutterBottom: true }, { children: [popupBeforeInputSearch, " ", page_locale_country] })), _jsx(CompanyAutoComplete, { countryCode: page_country_code, onCompanyChange: (co) => setSelectedCompany(co), placeholder: popupInputPlaceholder, popupBeforeInputSearchMinCharactersRequirement: popupBeforeInputSearchMinCharactersRequirement !== null && popupBeforeInputSearchMinCharactersRequirement !== void 0 ? popupBeforeInputSearchMinCharactersRequirement : "", popupOptionNoResultsWereFound: popupOptionNoResultsWereFound !== null && popupOptionNoResultsWereFound !== void 0 ? popupOptionNoResultsWereFound : "", popupURLNoResultsWereFound: popupURLNoResultsWereFound !== null && popupURLNoResultsWereFound !== void 0 ? popupURLNoResultsWereFound : "" }), _jsx(Typography, Object.assign({ gutterBottom: true, sx: { "a": { "a:hover": { "color": (theme) => theme.palette.common.white }, "color": (theme) => theme.palette.common.white, "textDecoration": "underline" } }, variant: "body2" }, { children: _jsx("span", { dangerouslySetInnerHTML: { "__html": afterInputText } }) }))] })), _jsx(DialogActions, { children: _jsx(Button, Object.assign({ disabled: isUndefined(selectedCompany), onClick: clickHandler, sx: {
                                "background": (theme) => theme.palette.common.white,
                            }, variant: "outlined" }, { children: popupNextButtonLabel })) })] })), _jsx(AnalyticsForm, Object.assign({}, cartObjectForAnalytics))] }));
};
export { CompanySelectorDialog };
